import types from './types'

export default {
  [types.SET_AFFECTED_APP](state, affectedAppData) {
    state.affectedApplicationData = affectedAppData;
  },
}
